import Api from '@/services/Api'

export default {
  getPatientVaccines () {
    return Api().get("/patient-vaccines");
  },
  updatePatientVaccine (params) {
    return Api().put("/patient-vaccines",params);
  },
  addPatientVaccine (params) {
    return Api().post("/patient-vaccines",params);
  },
  getPatientVaccine (params) {
    return Api().get("/patient-vaccines/"+params);
  },
  deletePatientVaccine(params) {
    return Api().delete("/patient-vaccines/"+params);
  },
  getByPatientRouteSheet(params) {
    return Api().get("/patient-vaccines/by-route-sheet/"+params);
  },
  getAlerts() {
    return Api().get("/patient-vaccines/alerts");
  },
  getByCompanyId(params) {
    return Api().get("patient-vaccines/by-company-id/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/PatientVaccineService.js